import { memo, PropsWithChildren, useEffect, useRef, useState } from "react";
import AdUnit, { AdUnitTypeEnum } from "components/ads/AdUnit";
import { AdUnitsKeys } from "./config/units";
import { useLocation } from "react-router-dom";
import "./WithSideAds.scss";
import { useExperiment } from "@/common/hooks/useExperiment";
import useWindowDimensions from "@/common/hooks/useWindowDimension";
import { EXPERIMENT_NO_ADS } from "@/common/services/experiment/constants";

const ADS_WIDTH = 384; // 2 × (160 + 16 + 16)

type WithSideAdsProps = PropsWithChildren<{
  leftAds?: AdUnitsKeys[];
  rightAds?: AdUnitsKeys[];
}>;

export const WithSideAds = memo((props: WithSideAdsProps) => {
  const { children, leftAds, rightAds } = props;
  const location = useLocation();
  const { variant: noAds } = useExperiment({ key: EXPERIMENT_NO_ADS, fallback: false });
  const isDesktop = useWindowDimensions();

  const [showAds, setShowAds] = useState<boolean>(isDesktop);

  const contentRef = useRef<HTMLDivElement | null>(null);

  const ref = useRef<HTMLDivElement | null>(null);
  const width = ref.current?.clientWidth ?? 0;

  useEffect(() => {
    if (width === 0) {
      return;
    }

    const contentWidth = contentRef.current?.clientWidth ?? 0;

    const maxWidth = contentWidth + ADS_WIDTH;
    setShowAds(width >= maxWidth);
  }, [width]);

  return (
    <div className="skyWrapper" ref={ref}>
      {!noAds && showAds && leftAds && <div className="left side">
        {
          leftAds.map(name => <AdUnit key={`${name}${location.key}`} name={name} type={AdUnitTypeEnum.DESKTOP}/>)
        }
      </div>}

      <div className="middle" ref={contentRef}>
        {children}
      </div>

      {!noAds && showAds && rightAds && <div className="right side">
        {
          rightAds.map(name => <AdUnit key={`${name}${location.key}`} name={name} type={AdUnitTypeEnum.DESKTOP}/>)
        }
      </div>}
    </div>
  );
});
